import request from '@/assets/js/http/request';
import { getDomain } from '@/assets/js/utils/browser';
import { updateCredentials } from '@/services/AuthService';

const domain = getDomain() ? getDomain()[0] : '.com';
const HOST = `${process.env.API_FRONT}${domain}`;

const RESET_PASSWORD = `${HOST}/client/resetPassword`;
const CONFIRM_PASSWORD = `${HOST}/client/setUserPassword`;

function resetPassword(email, locale) {
  return request.post(RESET_PASSWORD, { email, locale })
    .then(({ status }) => {
      if (status === 'success') {
        return Promise.resolve();
      }
      return Promise.reject();
    });
}

function confirmPassword(payload) {
  return request.post(CONFIRM_PASSWORD, payload)
    .then(({ status, data }) => {
      if (status === 'success') {
        updateCredentials(data, true);
        return Promise.resolve();
      }
      return Promise.reject(new Error('token invalid'));
    });
}

export default {
  resetPassword,
  confirmPassword,
};



// WEBPACK FOOTER //
// ./src/services/SalesForce.js